/* Familia Ramírez · Menú móvil y carrito (Rediseño 2026)
   - Carrito lateral y página /cart con la Cart API de Shopify (/cart.js, /cart/add.js, /cart/change.js, /cart/update.js)
   - Se abre desde el icono de la cabecera y cada vez que se añade algo
   - Foco atrapado, Escape cierra y el scroll de la página queda bloqueado
   - window.RZCart = { add, refresh, open, close } para el resto del tema */
(function () {
  'use strict';
  if (window.RZCart) return;

  var cfgEl = document.getElementById('rz-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.textos || {};
  var R = C.rutas || {};
  var cart = C.cart || { items: [], item_count: 0 };
  var nota = cart.note || '';
  var mensaje = '';
  var ocupado = false;

  var html = document.documentElement;
  var drawer = document.getElementById('rz-drawer');
  /* El menú está en la sección de cabecera: se busca cada vez porque el personalizador puede volver a pintarla */
  function elMenu() { return document.getElementById('rz-menu'); }
  function elBotonMenu() { return document.querySelector('[data-rz-open-menu]'); }
  var ultimoFoco = null;

  /* ---------- Utilidades ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function decodificar(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }
  var formato = decodificar(C.moneyFormat || '{{amount_with_comma_separator}} €');
  function precio(centimos) {
    var valor = Number(centimos) || 0;
    function separar(n, decimales, miles, coma) {
      var partes = (n / 100).toFixed(decimales).split('.');
      return partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles) + (partes[1] ? coma + partes[1] : '');
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      switch (tipo) {
        case 'amount': return separar(valor, 2, ',', '.');
        case 'amount_no_decimals': return separar(valor, 0, ',', '.');
        case 'amount_with_comma_separator': return separar(valor, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return separar(valor, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return separar(valor, 2, "'", '.');
        case 'amount_with_space_separator': return separar(valor, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return separar(valor, 0, ' ', ',');
        default: return separar(valor, 2, '.', ',');
      }
    });
  }
  function conAncho(url, ancho) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + ancho;
  }
  function postJSON(url, datos) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }
  function textoError(err) {
    return (err && (err.description || err.message)) || 'No se ha podido actualizar el carrito.';
  }

  /* ---------- Bloqueo del scroll y foco ---------- */
  function capaAbierta() {
    var menu = elMenu();
    return (drawer && !drawer.hidden) || (menu && !menu.hidden);
  }
  function bloquear(activar) {
    document.body.classList.toggle('rz-locked', activar);
    if (activar) html.setAttribute('scroll-lock', '');
    else if (!capaAbierta()) html.removeAttribute('scroll-lock');
  }
  function enfocables(contenedor) {
    return Array.prototype.filter.call(
      contenedor.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
  }
  function atrapar(contenedor, e) {
    if (e.key !== 'Tab') return;
    var lista = enfocables(contenedor);
    if (!lista.length) return;
    var primero = lista[0], ultimo = lista[lista.length - 1];
    if (e.shiftKey && document.activeElement === primero) { ultimo.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { primero.focus(); e.preventDefault(); }
  }

  /* ---------- Menú móvil ---------- */
  function abrirMenu() {
    var menu = elMenu(), botonMenu = elBotonMenu();
    if (!menu) return;
    ultimoFoco = document.activeElement;
    menu.hidden = false;
    bloquear(true);
    if (botonMenu) botonMenu.setAttribute('aria-expanded', 'true');
    var cerrar = menu.querySelector('[data-rz-close-menu]');
    if (cerrar) cerrar.focus();
  }
  function cerrarMenu(devolverFoco) {
    var menu = elMenu(), botonMenu = elBotonMenu();
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    bloquear(false);
    if (botonMenu) botonMenu.setAttribute('aria-expanded', 'false');
    if (devolverFoco !== false && ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  /* Sin foto del producto, la de su formato (misma regla que snippets/rz-foto-formato.liquid) */
  function fotoFormato(titulo) {
    var t = String(titulo || '').toLowerCase(), F = C.fotosFormato || {};
    if (t.indexOf('garrafa') > -1) return t.indexOf(' 5 l') > -1 ? F.garrafa5 : F.garrafa2;
    if (t.indexOf('hosteler') > -1) return F.hosteleria;
    return F.hogar || '';
  }

  /* ---------- Carrito: pintar ---------- */
  function linea(item) {
    var img = item.image ? conAncho(item.image, 200) : fotoFormato(item.product_title);
    var variante = (item.options_with_values || [])
      .map(function (o) { return o.value; })
      .filter(function (v) { return v && v.toLowerCase() !== 'default title'; })
      .concat(Object.keys(item.properties || {})
        .filter(function (k) { return k.charAt(0) !== '_' && item.properties[k]; })
        .map(function (k) { return k + ': ' + item.properties[k]; }))
      .join(' · ');
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var nombre = esc(item.product_title);
    return '<div class="rz-line">' +
      (img
        ? '<a class="rz-line__img" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img) + '" alt="" width="76" height="92" loading="lazy"></a>'
        : '<div class="rz-line__img" aria-hidden="true"></div>') +
      '<div class="rz-line__info">' +
        '<div class="rz-line__top"><a href="' + esc(item.url) + '">' + nombre + '</a><span>' + esc(precio(item.final_line_price)) + '</span></div>' +
        (variante ? '<span class="rz-line__variant">' + esc(variante) + '</span>' : '') +
        (plan ? '<span class="rz-sub-badge">Suscripción · ' + esc(plan.name) + '</span>' : '') +
        '<div class="rz-line__actions">' +
          '<div class="rz-stepper">' +
            '<button type="button" data-rz-qty="' + (item.quantity - 1) + '" data-key="' + esc(item.key) + '" aria-label="Quitar uno de ' + nombre + '">−</button>' +
            '<span aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-rz-qty="' + (item.quantity + 1) + '" data-key="' + esc(item.key) + '" aria-label="Añadir uno de ' + nombre + '">+</button>' +
          '</div>' +
          '<button type="button" class="rz-link-btn" data-rz-qty="0" data-key="' + esc(item.key) + '">Eliminar</button>' +
        '</div>' +
      '</div></div>';
  }

  function pintarEn(caja, uid) {
    var cuerpo = caja.querySelector('[data-rz-cart-body]');
    var pie = caja.querySelector('[data-rz-cart-foot]');
    if (!cuerpo || !pie) return;
    var items = cart.items || [];
    var aviso = mensaje ? '<p class="rz-notice rz-cart-msg" role="alert">' + esc(mensaje) + '</p>' : '';

    if (!items.length) {
      cuerpo.innerHTML = aviso + '<div class="rz-empty"><strong>' + esc(T.vacioTitulo) + '</strong>' +
        '<span class="rz-lead">' + esc(T.vacioTexto) + '</span>' +
        '<a class="rz-btn rz-btn--dark" href="' + esc(R.root) + '#inicio" data-rz-go-shop>' + esc(T.vacioBoton) + '</a></div>';
      pie.hidden = true;
      pie.innerHTML = '';
      return;
    }

    var tieneRegalo = C.regalo && items.some(function (i) { return i.product_id === C.regalo.productId; });
    var h = aviso + items.map(linea).join('');
    if (C.regalo && !tieneRegalo) {
      h += '<div class="rz-upsell">' +
        (C.regalo.img ? '<div class="rz-upsell__img"><img src="' + esc(C.regalo.img) + '" alt="" width="60" height="60" loading="lazy"></div>' : '') +
        '<div class="rz-upsell__text"><small>' + esc(T.regaloAntetitulo) + '</small><strong>' + esc(C.regalo.titulo) + ' · ' + esc(C.regalo.precio) + '</strong></div>' +
        '<button type="button" class="rz-btn rz-btn--outline" data-rz-add="' + C.regalo.variantId + '">Añadir</button></div>';
    }
    h += '<div class="rz-note"><label for="rz-nota-' + uid + '">' + esc(T.notaEtiqueta) + '</label>' +
      '<textarea id="rz-nota-' + uid + '" name="note" form="rz-checkout-' + uid + '" rows="2" placeholder="' + esc(T.notaPlaceholder) + '" data-rz-note>' + esc(nota) + '</textarea></div>';
    cuerpo.innerHTML = h;

    var descuento = (cart.items_subtotal_price || 0) - (cart.total_price || 0);
    pie.hidden = false;
    pie.innerHTML = '<form id="rz-checkout-' + uid + '" action="' + esc(R.cart) + '" method="post">' +
      '<div class="rz-row"><span>Subtotal</span><span>' + esc(precio(cart.items_subtotal_price)) + '</span></div>' +
      (descuento > 0 ? '<div class="rz-row rz-row--discount"><span>Descuento</span><span>−' + esc(precio(descuento)) + '</span></div>' : '') +
      '<div class="rz-row"><span>Envío</span><span class="rz-free">Gratis</span></div>' +
      '<div class="rz-row rz-row--total"><span>Total</span><strong>' + esc(precio(cart.total_price)) + '</strong></div>' +
      '<button type="submit" name="checkout" class="rz-btn rz-btn--gold">Finalizar compra</button>' +
      (T.pago ? '<span class="rz-secure">' + esc(T.pago) + '</span>' : '') +
      '</form>';
  }

  function pintar() {
    var n = cart.item_count || 0;
    document.querySelectorAll('[data-rz-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.hidden = n === 0;
    });
    document.querySelectorAll('[data-rz-open-cart]').forEach(function (a) {
      a.setAttribute('aria-label', 'Abrir carrito, ' + n + (n === 1 ? ' producto' : ' productos'));
    });
    document.querySelectorAll('[data-rz-cart-title-count]').forEach(function (s) { s.textContent = '(' + n + ')'; });
    document.querySelectorAll('[data-rz-cart-box]').forEach(function (caja, i) { pintarEn(caja, i); });
  }

  /* ---------- Carrito: acciones ---------- */
  function refrescar() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; nota = c.note || nota; pintar(); return c; });
  }
  function cambiar(key, cantidad) {
    if (ocupado) return Promise.resolve();
    ocupado = true;
    mensaje = '';
    document.querySelectorAll('[data-rz-cart-box]').forEach(function (c) { c.setAttribute('aria-busy', 'true'); });
    return postJSON(R.change + '.js', { id: key, quantity: Math.max(0, cantidad) })
      .then(function (c) { cart = c; })
      .catch(function (err) { mensaje = textoError(err); })
      .then(function () {
        ocupado = false;
        document.querySelectorAll('[data-rz-cart-box]').forEach(function (c) { c.removeAttribute('aria-busy'); });
        pintar();
      });
  }
  function anadir(items) {
    mensaje = '';
    return postJSON(R.add + '.js', { items: items }).then(refrescar);
  }
  var temporizadorNota = null;
  function guardarNota(valor) {
    nota = valor;
    clearTimeout(temporizadorNota);
    temporizadorNota = setTimeout(function () {
      postJSON(R.update + '.js', { note: valor }).catch(function () { /* se reintenta al finalizar la compra */ });
    }, 500);
  }

  /* ---------- Carrito: abrir y cerrar ---------- */
  function abrir(origen) {
    if (!drawer) return;
    cerrarMenu(false);
    if (drawer.hidden) ultimoFoco = origen || document.activeElement;
    drawer.hidden = false;
    bloquear(true);
    var cerrar = drawer.querySelector('.rz-close-btn');
    if (cerrar) cerrar.focus();
  }
  function cerrar() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    bloquear(false);
    if (ultimoFoco && ultimoFoco.focus && document.contains(ultimoFoco)) ultimoFoco.focus();
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-rz-open-cart]'))) { e.preventDefault(); abrir(el); return; }
    if ((el = t.closest('[data-rz-close-cart]'))) { cerrar(); return; }
    if ((el = t.closest('[data-rz-open-menu]'))) { abrirMenu(); return; }
    if ((el = t.closest('[data-rz-close-menu]'))) { cerrarMenu(); return; }
    if ((el = t.closest('[data-rz-menu-link]'))) { cerrarMenu(false); return; }
    if ((el = t.closest('[data-rz-go-shop]'))) { cerrar(); return; }
    if ((el = t.closest('[data-rz-qty]'))) {
      cambiar(el.getAttribute('data-key'), +el.getAttribute('data-rz-qty'));
      return;
    }
    if ((el = t.closest('[data-rz-add]'))) {
      if (el.disabled) return;
      el.disabled = true;
      anadir([{ id: +el.getAttribute('data-rz-add'), quantity: 1 }])
        .then(function () { abrir(el); })
        .catch(function (err) { mensaje = textoError(err); pintar(); abrir(el); })
        .then(function () { el.disabled = false; });
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-rz-note]')) guardarNota(e.target.value);
  });
  document.addEventListener('keydown', function (e) {
    var menu = elMenu();
    if (e.key === 'Escape') {
      if (drawer && !drawer.hidden) cerrar();
      else if (menu && !menu.hidden) cerrarMenu();
      return;
    }
    if (drawer && !drawer.hidden) atrapar(drawer, e);
    else if (menu && !menu.hidden) atrapar(menu, e);
  });

  /* Formularios del tema Horizon que siguen en otras páginas (colecciones, plantillas anteriores) */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var d = e.detail || {};
    Promise.resolve(d.promise).catch(function () {}).then(function () {
      setTimeout(function () {
        refrescar().then(function () { if (!d.action || d.action === 'add') abrir(); });
      }, 150);
    });
  });

  /* Botón «Elegir» de las tarjetas de producto de Horizon (colecciones generales y búsqueda):
     la ficha nueva no usa el formulario de Horizon, así que lleva a la ficha en vez de abrir la ventana rápida. */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('.quick-add__button--choose');
    if (!boton) return;
    var tarjeta = boton.closest('product-card') || boton.closest('.product-card');
    var enlace = tarjeta && tarjeta.querySelector('a[href*="/products/"]');
    if (!enlace) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = enlace.href;
  }, true);

  /* ---------- Botón de WhatsApp: nunca tapa la compra ---------- */
  var botonWa = document.querySelector('.rz-wa');
  if (botonWa) {
    var EVITAR = '.rz-buybar,.rz-opt,.rz-btn,.rz-row,.rz-line__top,.rz-line__actions,.rz-carousel__arrow,.rz-pack,.rz-steps li,main p,main h1,main h2,main h3,main li,main blockquote,main summary,main strong,main .rz-perk';
    var pendiente = false;
    var colocarWa = function () {
      pendiente = false;
      /* En la ficha va justo encima de la barra de compra mientras la barra esté abajo */
      var barra = document.querySelector('.rz-buybar');
      var alto = window.innerHeight;
      var encimaDeBarra = false;
      if (barra) {
        var b = barra.getBoundingClientRect();
        encimaDeBarra = b.top < alto && b.bottom + 12 > alto - 16 - botonWa.offsetHeight;
        if (encimaDeBarra) botonWa.style.bottom = (alto - b.top + 12) + 'px';
      }
      if (!encimaDeBarra) botonWa.style.bottom = 'calc(16px + env(safe-area-inset-bottom, 0px))';
      /* Se aparta mientras esté sobre un texto, un precio, una opción, un botón o una línea del carrito */
      var r = botonWa.getBoundingClientRect();
      var tapa = Array.prototype.some.call(document.querySelectorAll(EVITAR), function (el) {
        var e = el.getBoundingClientRect();
        return e.width > 0 && r.left < e.right && e.left < r.right && r.top < e.bottom && e.top < r.bottom;
      });
      botonWa.classList.toggle('rz-wa--apartado', tapa);
    };
    var pedirColocar = function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(colocarWa);
    };
    window.addEventListener('scroll', pedirColocar, { capture: true, passive: true });
    window.addEventListener('resize', pedirColocar);
    window.addEventListener('load', pedirColocar);
    /* Elegir una opción o cambiar el carrito mueve la barra y las líneas */
    document.addEventListener('click', function () { setTimeout(pedirColocar, 50); setTimeout(pedirColocar, 800); });
    colocarWa();
  }

  window.RZCart = { add: anadir, refresh: refrescar, open: abrir, close: cerrar };
  pintar();
})();
